import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseDialogOptions } from '../dialogoptions';

import { SchoolInfo, WindowTypeInfo, NomineeTypeInfo } from 'services/application/application.service';
import { ReportInfo } from 'services/reports/reports.service';

@Component({
    selector: 'dialog-reportoptions-component',
    styleUrls: ['reportoptions.dialogcomponent.scss'],
    templateUrl: 'reportoptions.dialogcomponent.html',
})
export class ReportOptionsDialogComponent implements OnInit {
    title: string;
    message: string;
    oktext: string;
    canceltext: string;

    AllSchoolYears: string[];
    AvailableSchools: SchoolInfo[];
    AvailableWindowTypes: WindowTypeInfo[];
    AvailableNomineeTypes: NomineeTypeInfo[];
    JudgingPhase: string;
    OptionsForm: FormGroup;
    ReportInfo: ReportInfo;
    SchoolNumber: string;
    SchoolYear: string;
    showIcon: boolean;
    iconcolor: string;
    iconname: string;

    constructor(
        private dialogRef: MatDialogRef<ReportOptionsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: BaseReportOptionsDialogOptions,
        private fb: FormBuilder
    ) {
        this.title = data.TitleText || 'Information';
        this.message = data.MessageText || '';
        this.oktext = data.OKText || 'OK';
        this.canceltext = data.CancelText || 'Cancel';

        this.AllSchoolYears = data.AllSchoolYears || [];
        this.AvailableSchools = data.AvailableSchools || [];
        this.AvailableWindowTypes = data.AvailableWindowTypes || [];
        this.AvailableNomineeTypes = data.AvailableNomineeTypes || [];
        this.JudgingPhase = null;
        this.ReportInfo = data.ReportInfo;
        this.SchoolNumber = data.SchoolNumber;

        this.showIcon = data.ShowIcon || false;
        this.iconcolor = data.IconColor || 'primary';
        this.iconname = data.IconName || '';

        let yearInitialValue = this.AllSchoolYears && !!this.AllSchoolYears.length ? this.AllSchoolYears[0] : null;
        let nomTypeInitialValue = this.AvailableNomineeTypes && this.AvailableNomineeTypes.length === 1 ? this.AvailableNomineeTypes[0].NomineeTypeID : null;

        // If there's only a single available school, preselect it
        let schoolInitialValue = null;

        if (this.AvailableSchools && this.AvailableSchools.length === 1) {
            schoolInitialValue = this.AvailableSchools[0];
        } else {
            // If there's more, AND we can select the school, AND the first item is "Entire District 0000", select it.
            if (this.ReportInfo.CanSetSchool && this.AvailableSchools[0].SchoolNumber === '0000') {
                schoolInitialValue = this.AvailableSchools[0];
            }
        }

        this.OptionsForm = this.fb.group({
            ReportSchool: [schoolInitialValue],
            ReportYear: [yearInitialValue, Validators.required],
            ReportJudgingPhase: [null],
            ReportNomineeType: [nomTypeInitialValue, Validators.required],
        });

        if (this.ReportInfo.CanSetNomType) {
            this.OptionsForm.get('ReportNomineeType').enable();
        } else {
            this.OptionsForm.get('ReportNomineeType').disable();
        }
    }

    ngOnInit() {}

    CancelHandler() {
        this.dialogRef.close(null);
    }

    OKHandler() {
        const form = this.OptionsForm.value;

        this.dialogRef.close(<BaseReportOptionsResult>{
            ReportInfo: this.ReportInfo,
            ReportSchool: form.ReportSchool,
            ReportYear: form.ReportYear,
            ReportJudgingPhase: form.ReportJudgingPhase,
            ReportNomineeType: form.ReportNomineeType,
        });
    }
}

export class BaseReportOptionsDialogOptions extends BaseDialogOptions {
    AllSchoolYears?: string[];
    AvailableSchools?: SchoolInfo[];
    AvailableWindowTypes?: WindowTypeInfo[];
    AvailableNomineeTypes: NomineeTypeInfo[];
    ReportInfo?: ReportInfo;
    SchoolNumber?: string;
}

export class BaseReportOptionsResult {
    ReportInfo: ReportInfo;
    ReportSchool: SchoolInfo;
    ReportYear: string;
    ReportJudgingPhase: WindowTypeInfo;
    ReportNomineeType: number;
}
